import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { UserGetFailure, UserGetRequest, UserGetSuccess } from '../../store/user/user.actions';
import { selectUser } from '../../store/user/user.selectors';
import { AuthStoreService } from '../../core/services';
import { ChannelFetchRequest } from '../../store/channel/channel.actions';
import { environment } from '../../../environments/environment';
import { WebSocketFacade } from '../../core/facade/websocket.facade';

@Component({
  selector: 'app-main',
  imports: [RouterOutlet],
  templateUrl: './main.html',
  styleUrl: './main.scss',
})
export class Main {
  private readonly store = inject(Store);
  private readonly authStore = inject(AuthStoreService);
  private readonly chatSocketFacade = inject(WebSocketFacade);
  private readonly actions$ = inject(Actions);

  ngOnInit(): void {
    this.store.select(selectUser).pipe(take(1)).subscribe((user) => {
      if (user) {
        this.initializeWorkspace();
        return;
      }

      this.store.dispatch(UserGetRequest());
      this.actions$.pipe(ofType(UserGetSuccess, UserGetFailure), take(1)).subscribe((action) => {
        if (action.type === UserGetSuccess.type) {
          this.initializeWorkspace();
        }
      });
    });
  }

  private initializeWorkspace(): void {
    this.chatSocketFacade.connect(
      environment.wsUrl,
      String(this.authStore.token())
    );
    this.store.dispatch(ChannelFetchRequest());
  }

}
